import { data } from "react-router-dom"
import Single from "../../components/single/Single.tsx"
import "./organization.scss"
import React from 'react'

const singleOrga = {
  id: 1,
  title: "Landkreis Leer",
  info: {
    orgaId: "1233434",

  },
  activities: [
    {
      text: "John Doe machte Blödsinn",
      time: "Vor 5 Minuten"
    },
    {
      text: "John Doe hatte eine blöde Idee",
      time: "Vor 10 Minuten"
    }
  ],
  chart: {
    dataKeys: [
      { name: "Einsätze", color: "#82ca9d"},
      { name: "Abgeschlossen", color: "#8884d8"}
    ],
    data: [
      {
        name: '18:00',
        Einsätze: 0,
        Abgeschlossen: 0,
      },
      {
        name: '18:30',
        Einsätze: 1,
        Abgeschlossen: 0,
      },
      {
        name: '19:00',
        Einsätze: 0,
        Abgeschlossen: 0,
      },
      {
        name: '19:30',
        Einsätze: 0,
        Abgeschlossen: 8,
      },
      {
        name: '20:00',
        Einsätze: 10,
        Abgeschlossen: 8,
      },
      {
        name: '20:30',
        Einsätze: 0,
        Abgeschlossen: 11,
      },
      {
        name: '21:00',
        Einsätze: 0,
        Abgeschlossen: 11,
      },
      {
        name: '21:30',
        Einsätze: 0,
        Abgeschlossen: 11,
      },
      {
        name: '22:00',
        Einsätze: 0,
        Abgeschlossen: 11,
      },
      {
        name: '22:30',
        Einsätze: 0,
        Abgeschlossen: 11,
      },
      {
        name: '23:00',
        Einsätze: 0,
        Abgeschlossen: 11,
      },
      {
        name: '23:30',
        Einsätze: 0,
        Abgeschlossen: 11,
      },
      {
        name: '0:00',
        Einsätze: 0,
        Abgeschlossen: 11,
      },
    ],
  }

}
const Organization = () => {
  return (
    <div className="organization">
      <Single {...singleOrga} />
    </div>
  )
}

export default Organization